export const POPULATE = 'LandingZoneGroupsPopulate'

export const SET_LOADED = 'LandingZoneGroupsSetLoaded'

export const SET_FORMAT = 'LandingZoneGroupsSetFormat'